export default __webpack_public_path__ + "static/media/Pharmacist Call.c0ca8cce.png";